export enum SearchAndFilterByTestIds {
  root = 'search-and-filter-by',
  searchQueryInput = 'input',
}

export enum CommentThreadTestIds {
  root = 'comment-thread',
  goToCommentButton = 'go-to-button',
}
